import CustomButton from "../UI/Buttons/CustomButton";

export enum VacancyMessageType {
  CANDIDATE_UNAVAILABLE = "CANDIDATE_UNAVAILABLE",
  NO_MATCHES_FOUND = "NO_MATCHES_FOUND",
}

export interface VacancyMessageConfig {
  title: string;
  content: string;
  buttonLabel: string;
}

export const vacancyMessageConfigs: Record<
  VacancyMessageType,
  VacancyMessageConfig
> = {
  [VacancyMessageType.CANDIDATE_UNAVAILABLE]: {
    title: "This candidate is no longer available",
    content:
      "The individual has either just been chosen for another vacancy or has just accepted another vacancy.\n\nPlease return to the edit page and select another candidate.",
    buttonLabel: "Return To Edit",
  },
  [VacancyMessageType.NO_MATCHES_FOUND]: {
    title: "No matches from your preferred list",
    content:
      "We recommend adding more candidates to your preferred list or changing your settings for who can view and accept your vacancy. You will then be able to find more suitable candidates.",
    buttonLabel: "Return To Edit",
  },
};

interface VacancyMessageProps {
  type: VacancyMessageType;
  onReturn: () => void;
}

const VacancyMessage: React.FC<VacancyMessageProps> = ({ type, onReturn }) => {
  const config = vacancyMessageConfigs[type];

  return (
    <>
      <div className="fs-22 fs-mobile-16 fw-400 text-black">{config?.title}</div>
      <div className="gap-8">
        <div className="fs-13 fw-400 text-black">{config?.content}</div>
      </div>
      <div className="d-flex justify-content-end">
        <CustomButton
          variant={"primary"}
          type="button"
          className="btn-theme bg-teal text-black mobile-w-100"
          onClick={onReturn}
        >
          {config?.buttonLabel}
        </CustomButton>
      </div>
    </>
  );
};

export default VacancyMessage;
